import { useCallback, useState } from 'react';
import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

const MINI_KEY = 'wheels.sidebar.mini';

export function AppShellLayout() {
  const [opened, { toggle }] = useDisclosure(false);
  // Minimized = icon-only rail. Persisted so the operator's choice
  // survives reloads.
  const [mini, setMini] = useState(() => localStorage.getItem(MINI_KEY) === '1');
  const toggleMini = useCallback(() => {
    setMini((m) => {
      localStorage.setItem(MINI_KEY, m ? '0' : '1');
      return !m;
    });
  }, []);

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: mini ? 68 : 260,
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      padding="lg"
      styles={{
        navbar: {
          backgroundColor: 'var(--wheels-sidebar-bg)',
          borderInlineEnd: '1px solid rgba(255,255,255,0.04)',
          color: 'var(--wheels-sidebar-ink)',
          transition: 'width 160ms ease',
        },
        main: {
          backgroundColor: 'var(--wheels-bg)',
          minHeight: '100vh',
        },
      }}
    >
      <AppShell.Header withBorder={false}>
        <Topbar navbarOpened={opened} onNavbarToggle={toggle} />
      </AppShell.Header>

      <AppShell.Navbar p={0}>
        <Sidebar mini={mini} onToggleMini={toggleMini} />
      </AppShell.Navbar>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
